"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
(function () {
    var exports = {
        /**
         * Track events
         *
         * @param {object} $element The element triggering the event
         */
        trackGtmEvent: function ($element) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': $element.data('triggerGtmEvent'),
                'eventCategory': $element.data('triggerGtmEventCategory'),
                'eventAction': $element.data('triggerGtmEventAction'),
                'eventLabel': $element.data('triggerGtmEventLabel')
            });
        },
        /**
         * Track virtual page views
         *
         * @param {object} $element The element triggering the event
         */
        trackGtmPage: function ($element) {
            var anchorText = $element.find('.panel-title a')
                .text()
                .toLowerCase()
                .replace(/\s/g, '-')
                .replace(/\?/g, '');
            anchorText = $.trim(anchorText);
            var path = window.location.pathname;
            if (path.substr(-1) !== '/') {
                path = path + '/';
            }
            var virtualPageName = path + 'fragen-und-antworten/' + anchorText + '/';
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'page': $element.data('triggerGtmEvent'),
                'virtual_pageName': virtualPageName
            });
        },
        /**
         * Add GTM Event Tracking
         */
        attachGtmEvents: function () {
            $('body').on('mousedown', '[data-trigger-gtm-event-wrapper="true"]', function (event) {
                var $element = $(this);
                if (typeof $element.data('triggerGtmEvent') === 'string') {
                    switch ($element.data('triggerGtmEvent')) {
                        case 'event':
                            exports.trackGtmEvent($element);
                            break;
                        case 'page':
                            exports.trackGtmPage($element);
                            break;
                        default:
                            exports.trackGtmEvent($element);
                            break;
                    }
                }
            });
        }
    };
    exports.attachGtmEvents();
})();
exports.default = {};
